import GooglePlay from "../../assets/images/home/google-play.svg";
import AppStore from "../../assets/images/home/appstore-logo.svg";
import FooterLogo from "../../assets/images/home/footer-logo.png";
import InstagramIcon from "../../assets/images/home/instagram.svg";
import FacebookIcon from "../../assets/images/home/facebook.svg";
import TikTokIcon from "../../assets/images/home/tiktok.svg";
import YoutubeIcon from "../../assets/images/home/youtube.svg";
import SnapchatIcon from "../../assets/images/home/snapchat.svg";
import TwitterIcon from "../../assets/images/home/twitter.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/uiSlice";
import { useTranslation } from "react-i18next";
import { getSocialMediaListAPI } from "../../api/cms";
import { useQuery } from "@tanstack/react-query";

export default function Footer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { data: socialMediaList } = useQuery({
    queryKey: ["socialMediaList"],
    queryFn: getSocialMediaListAPI,
  });
  const cmsPageNac = [
    {
      title: t("footer.home"),
      onClick: () => {
        navigate("/");
      },
    },
    {
      title: t("footer.about"),
      onClick: () => {
        navigate("/about");
      },
    },
    {
      title: t("footer.howToPlay"),
      onClick: () => {
        dispatch(openModal("playInfo"));
      },
    },
    {
      title: t("footer.faqs"),
      onClick: () => {
        navigate("/faq");
      },
    },
  ];

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const isLoggedIn = !!token;

  const secondCmsPageNac = [
    // {
    //   title: t("footer.contactUs"),
    //   onClick: () => {
    //     navigate("/contact-us");
    //   },
    // },
    {
      title: t("footer.privacyPolicies"),
      onClick: () => {
        navigate("/privacy-policy");
      },
    },
    {
      title: t("footer.termsAndConditions"),
      onClick: () => {
        navigate("/terms-conditions");
      },
    },
    // isLoggedIn && {
    //   title: t("footer.support"),
    //   onClick: () => {
    //     // open model to support model
    //     dispatch(openModal("support"));
    //   },
    // },
  ].filter(Boolean);

  const icons = {
    youtube: YoutubeIcon,
    instagram: InstagramIcon,
    facebook: FacebookIcon,
    tiktok: TikTokIcon,
    snapchat: SnapchatIcon,
    twitter: TwitterIcon,
  };

  const socialMedia = socialMediaList?.data?.map((socialMedia: any) => {
    return {
      link: socialMedia?.link,
      icon: icons[socialMedia?.media_name as keyof typeof icons],
    };
  });


  return (
    <footer
      className={`site-footer relative z-20 bg-[#F3E8D4]`}
    >
      <div className="w-full 2xl:max-w-[71.667vw] max-w-[86rem] mx-auto 2xl:px-[0.833vw] xl:px-10 px-4 relative z-20  2xl:pt-[3.021vw] lg:pt-14 pt-10">
        <div className="grid lg:grid-cols-3 md:grid-cols-5 grid-cols-1 2xl:gap-y-[1.667vw] md:gap-y-8 2xl:gap-x-[2.083vw] gap-x-6">
          <div className="lg:col-span-1 md:col-span-2 col-span-1 md:me-auto md:ms-0 mx-auto md:w-fit w-full md:border-b-0 border-b border-[#404040]/30 pb-4 md:pb-0 mb-4 md:mb-0">
            <img
              src={FooterLogo}
              alt=""
              className="2xl:h-[5.208vw] h-20 w-full block lg:me-auto md:mx-auto object-contain"
            />
            {/* <h6 className="font-garamond 2xl:text-[0.833vw]/tight text-base/tight font-medium capitalize text-white 2xl:mb-[0.625vw] mb-3">Sponsor By</h6>
            <div className="flex lg:gap-[0.7vw] gap-2">
              <div className="2xl:px-[0.729vw] px-3.5 2xl:py-[0.833vw] py-4 bg-white 2xl:rounded-[0.521vw] rounded-[10px]">
                <img src={FooterBlueLogo} alt="" className="2xl:max-w-[6.25vw] max-w-[120px] 2xl:h-[1.198vw] h-[23px] w-full block" />
              </div>
              <div className="2xl:px-[0.729vw] px-3.5 2xl:py-[0.833vw] py-4 bg-white 2xl:rounded-[0.521vw] rounded-[10px]">
                <img src={FooterLogoipsumLogo} alt="" className="2xl:max-w-[6.25vw] max-w-[120px] 2xl:h-[1.198vw] h-[23px] w-full block" />
              </div>
            </div> */}
          </div>
          {/* <div className="">
            <ul className="2xl:mt-[0.625vw] mt-0">
              {cmsPageNac.map((nav, index) => (
                <li key={index} className="2xl:not-last:mb-[1.354vw] xl:not-last:mb-6 not-last:mb-4">
                  <div
                    onClick={nav.onClick}
                    className="2xl:text-[0.938vw]/tight xl:text-lg text-base md:leading-6 leading-5 text-black-300 font-bold cursor-pointer"
                  >
                    {nav.title}
                  </div>
                </li>
              ))}
            </ul>
          </div> */}
          <div className="flex justify-center gap-6 items-center col-span-1  w-full md:border-b-0 border-b border-[#404040]/30 pb-4 md:pb-0 mb-4 md:mb-0">
            {/* <div className="flex flex-col gap-4 w-1/2 justify-center items-start md:items-center  ">
              <ul className="2xl:mt-[0.625vw] mt-0">
                {secondCmsPageNac.map((nav, index) => (
                  <li key={index} className="2xl:not-last:mb-[1.354vw] xl:not-last:mb-6 not-last:mb-4">
                    <div
                      onClick={nav.onClick}
                      className="2xl:text-[0.938vw]/tight xl:text-lg text-base md:leading-6 leading-5 text-black-300 font-bold cursor-pointer"
                    >
                      {nav.title}
                    </div>
                  </li>
                ))}
              </ul>
            </div> */}

            <div className="flex flex-col justify-center md:items-center items-start col-span-1">
              <h6 className="2xl:text-[1.25vw]/tight text-lg/tight capitalize text-black-300 font-bold lg:mb-[0.6vw] mb-2 w-full text-center">
                {t("footer.followUs")}
              </h6>
              <ul className="flex lg:gap-[1vw] gap-3 justify-center w-full">
                {socialMedia?.map((nav, index) => (
                  <li key={index}>
                    <div onClick={() => window.open(nav.link, "_blank")} className="cursor-pointer 2xl:w-[2.396vw] w-10">
                      <img src={nav.icon} alt="" className="h-full w-full object-contain" />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-1 md:col-span-2 col-span-1 w-auto flex flex-col justify-center md:ms-auto md:me-0 mx-auto">
            {/* <h6 className="2xl:text-[0.938vw]/tight text-lg/tight capitalize text-black-300 font-bold lg:mb-[0.6vw] mb-2">
              {t("footer.followUs")}
            </h6>
            <ul className="flex lg:gap-[1vw] gap-3 lg:mb-[1.5vw] mb-5">
              {socialMedia.map((nav, index) => (
                <li key={index}>
                  <div onClick={() => navigate(nav.link)} className="cursor-pointer">
                    <img src={nav.icon} alt="" className="2xl:w-[2.083vw] w-10" />
                  </div>
                </li>
              ))}
            </ul> */}
            <h6 className="2xl:text-[1.25vw]/tight text-lg/tight capitalize text-black-300 font-bold lg:mb-[0.6vw] mb-2 md:text-start text-center">
              {t("footer.downloadApp")}
            </h6>
            <div className="flex flex-row 2xl:gap-[0.521vw] xl:gap-2 gap-1">
              <img src={AppStore} alt="" className="2xl:h-[2.396vw] h-10 w-fit block" />
              <img src={GooglePlay} alt="" className="2xl:h-[2.396vw] h-10 w-fit block" />
            </div>
          </div>
        </div>


      </div>
      <div className="2xl:py-[1.25vw] xl:py-3 py-2 2xl:mt-[2vw] md:mt-7 mt-4 text-center border-t border-primary-orange">
        <p className="2xl:text-[1.25vw]/tight text-lg/tight capitalize text-black-300 font-bold text-black-300 font-bold">
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </p>
      </div>
    </footer>
  );
}
